import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class XYearService {
  private xYear = new BehaviorSubject<number>(new Date().getFullYear());
  selectedYear$: Observable<number> = this.xYear.asObservable();

  // Getter
  getYear(): number {
    return this.xYear.getValue();
  }

  // Setter
  updateYear(year: number): void {
    this.xYear.next(year);
  }
}
